import { createQueryKeys } from '@lukemorales/query-key-factory';

export const auth = createQueryKeys('auth', {
  loginUser: null,
  logoutUser: null,
  signUpUser: null,
  setNewUserPassword: null,
  completeUserRegistration: null,
  completePersonalData: null,
  changeLocale: null,
  verifyEmail: null,
  verifyPhoneNumber: null,
  requestVerificationCode: null,
});
